<template>
    <div class="time-flow flow-container">
        <ParamsHeader @searchParams="searchData" :data-conf="{ type: 'date' }"></ParamsHeader>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>高峰时段</span>
                </div>
            </template>
            <div class="card-content">
                <ChartMap class="chart-small" ref="chart"></ChartMap>
            </div>
        </Card>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>流量详情</span>
                    <div class="buttons">
                        <el-button icon="el-icon-delete" size="mini" type="success"> 导出数据 </el-button>
                    </div>
                </div>
            </template>
            <list-page
                v-if="searchParam"
                :showTitle="false"
                :api="searchUrl"
                :searchParam="searchParam"
                :showPager="false"
                :showSearch="false"
                ref="application"
            >
                <el-table-column type="index" width="80px" label="序号"></el-table-column>
                <el-table-column prop="AppName" label="应用名称"></el-table-column>
                <el-table-column prop="TenantName" label="租户"></el-table-column>
                <el-table-column prop="AppAK" label="应用标识(AK)"></el-table-column>
                <el-table-column prop="AppSK" label="应用密钥(SK)"></el-table-column>
                <el-table-column prop="MinInterval" label="接口最小调用间隔（秒）"></el-table-column>
            </list-page>
        </Card>
    </div>
</template>

<script>
import ParamsHeader from "../components/ParamsHeader2";
export default {
    name: "timeFlow",
    components: {
        ParamsHeader,
    },
    data() {
        return {
            dayList: [],
            hourList: [],
            dataList: [],
            maxData: 100,
            searchUrl: "/FlowData/GetPeakPeriod",
            searchParam: null,
        };
    },
    methods: {
        searchData(params) {
            let data = {
                EntityID: params.EntityID,
                BeginTime: params.Date,
                Date: params.Date,
            };
            this.searchParam = { ...data };
            this.setData(data);
        },
        setData(data) {
            this.$ajax.post("/FlowData/GetPeakPeriod", data).then((result) => {
                let arrDays = [];
                let arrHours = [];
                let data = [];
                let idx1 = 0;
                let idx2 = 0;
                let max = 100;
                for (let i = 0; i < result.Data.length; i++) {
                    let mdl = result.Data[i];
                    if (arrDays.filter((r) => r === mdl.Name).length === 0) {
                        arrDays.push(mdl.Name);
                        idx1 = arrDays.length - 1;
                        idx2 = 0;
                    }
                    data.push([idx1, idx2, mdl.DataIn]);
                    max = Math.max(max, mdl.DataIn);
                    idx2++;
                    if (arrHours.filter((r) => r == mdl.ChildName).length === 0) {
                        arrHours.push(mdl.ChildName);
                    }
                }
                this.dayList = arrDays;
                this.hourList = arrHours;
                this.dataList = data;
                this.maxData = max;

                let opt = this.getOptions();
                this.$refs.chart.setData(opt, true);
            });
        },
        getOptions() {
            let days = this.dayList;
            let hours = this.hourList;
            let data = this.dataList;
            data = data.map(function (item) {
                return [item[1], item[0], item[2] || "-"];
            });
            let option = {
                tooltip: {
                    position: "top",
                },
                grid: {
                    height: "80%",
                    top: "10%",
                    left: "50px",
                    right: "10px",
                },
                xAxis: {
                    type: "category",
                    data: hours,
                    splitArea: {
                        show: true,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    type: "category",
                    data: days,
                    splitArea: {
                        show: true,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                visualMap: {
                    min: 0,
                    max: this.maxData,
                    calculable: true,
                    orient: "horizontal",
                    right: "10px",
                    top: "0px",
                    itemWidth: "10px",
                    itemHeight: "150px",
                    textGap: 20,
                    inRange: {
                        color: ["#8dc97c", "#fcea83", "#fd933d", "#ff706e"],
                    },
                },
                series: [
                    {
                        name: "客流量",
                        type: "heatmap",
                        data: data,
                        label: {
                            show: true,
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };
            return option;
        },
    },
};
</script>

<style scoped></style>
